
import $ from 'zepto'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Spinner from 'vux/src/components/spinner/index.vue'

import RoundCard from '../components/league/roundCard.vue'
import RoundCardUnstart from '../components/league/roundCardUnstart.vue'
import {wxShareConfig} from '../js/common/utils'
import configInfo from "../configInfo.js"
export default {
props: {



},
components: {
Tab,
TabItem,
Scroller,
Divider,
XSwitch,
Group,
Spinner,
ButtonTab,
ButtonTabItem,
Flexbox,
FlexboxItem,
RoundCardUnstart,
RoundCard
},
mounted(){
if(this.eventHub){
this.eventHub.$on('loadMoreArrange', () => {
this.loadMore();
})
this.eventHub.$on('refreshTabArrange', () => {
this.refreshTab();
})
}

this.currentTab = this.$store.getters.getArrangeTab;
this.nodataTxt = "";
this.roundsInfo = [];
this.initTab();
},
beforeRouteLeave (to, from, next) {
if(this.currentPage){

}
next();
},
methods: {
initWxShareConfig:function(){
this.currentPage = window.location.href;
var fullPath = window.location.href;


var shareImg = window.location.origin + configInfo.routerBase + "static/logo.png";
if (this.leagueBasicInfo.league_logo) {
shareImg = this.hagkApi.getImgAssetById(this.leagueBasicInfo.league_logo).url;
}
console.log(fullPath)


wxShareConfig({
title: this.leagueBasicInfo.title+'-赛况分享',
desc: "来自未来足球赛事系统",
link: fullPath,
imgUrl: shareImg,
type: 'link',
dataUrl: ''
}, () => {
console.log("share success")
}, () => {
console.log("share error")
});
},
handlerMatchFinish(){
this.currentTab = 'league-1';
this.$store.commit('updateArrangeTab', 'league-1');
this.initTab1();
$('#matchFinished').show();
$('#matchUnstart').hide();
},
handlerMatchUnstart(){
this.currentTab = 'league-2';
this.$store.commit('updateArrangeTab', 'league-2');
this.initTab1();
$('#matchFinished').hide();
$('#matchUnstart').show();
},
loadData(id, start, length, type, successCall, afterCall){
this.hagkHttp(this.hagkApi.getLeagueMatches(id, start, length, type), {})
.then((res) => {
if (res.status == true) {
successCall(res.result);
}
afterCall();
}, (error) => {
afterCall();
});
},
initTab(){
this.eventHub.$emit("setTabIndex", "leagueArrange");
this.initWxShareConfig();
if(this.currentTab == "league-1") {
$('#matchFinishTab').triggerFastClick();
} else {
$('#matchUnstartTab').triggerFastClick();
}
},
initTab1(){
console.log("init " + this.currentTab);
this.nodataTxt = "";
var leagueId = parseInt(this.leagueId)
if (this.currentTab == 'league-1') {
if(this.roundsInfo.length == 0){
console.log("加载中...")
this.$vux.loading.show({
text: '加载中...'
})
this.loadData(leagueId, 0, 3, "true", this.initRoundFinishInfo, () => {
console.log("取消加载中...")
this.$vux.loading.hide()
})
}
} else if (this.currentTab == 'league-2') {
if(this.roundsUnstartInfo.length == 0){
this.$vux.loading.show({
text: '加载中...'
})
this.loadData(leagueId, 0, 3, "false", this.initRoundUnstartInfo, () => {
this.$vux.loading.hide()
})
}
}
},
refreshTab(){
console.log("refreshTab" + this.currentTab);
this.nodataTxt = "";
var leagueId = parseInt(this.leagueId)
if (this.currentTab == 'league-1') {
this.loadData(leagueId, 0, 3, "true", this.initRoundFinishInfo, () => {
this.eventHub.$emit("enablerefreshTab")
})
} else if (this.currentTab == 'league-2') {
this.loadData(leagueId, 0, 3, "false", this.initRoundUnstartInfo, () => {
this.eventHub.$emit("enablerefreshTab")
})
}
},
loadMore(){
console.log("loadMore" + this.currentTab);
this.nodataTxt = "";
var leagueId = parseInt(this.leagueId)
if (this.currentTab == 'league-1') {
this.loadData(leagueId, this.roundStart, 3, "true", this.loadMoreRoundFinishInfo, () => {
this.eventHub.$emit("enableloadMore")
})
} else if (this.currentTab == 'league-2') {
this.loadData(leagueId, this.roundUnstartStart, 3, "false", this.loadMoreRoundUnstartInfo, () => {
this.eventHub.$emit("enableloadMore")
})
}
},
initRoundFinishInfo(data){
if (data && data.length > 0) {
this.roundStart = data.length;
this.roundsInfo = data;
} else {
this.roundStart = 0;
this.roundsInfo = [];
this.nodataTxt = "暂无数据";
}
},
loadMoreRoundFinishInfo(data) {
if (data && data.length > 0) {
this.roundStart += data.length;
for (var i = 0; i < data.length; i++) {
this.roundsInfo.push(data[i])
}
} else {
this.nodataTxt = "暂无数据";
}
return;
},
initRoundUnstartInfo(data){
if (data && data.length > 0) {
this.roundUnstartStart = data.length;
this.roundsUnstartInfo = data;
} else {
this.roundUnstartStart = 0;
this.roundsUnstartInfo = [];
this.nodataTxt = "暂无数据";
}
},
loadMoreRoundUnstartInfo(data) {
var offset = this.roundUnstartStart;
if (data && data.length > 0) {
this.roundUnstartStart += data.length;
for (var i = 0; i < data.length; i++) {
this.roundsUnstartInfo.push(data[i])
}
} else {
this.nodataTxt = "暂无数据";
}
return;
}
},
data () {
var loadingTab = ['league-1', 'league-2'];
return {
currentPage:null,
nodataTxt:"",
roundStart: 0,
roundsInfo: [],
roundUnstartStart: 0,
roundsUnstartInfo: [],
leagueId:this.$route.query.leagueId,
eventHub:this.$store.getters.getEventHub,
leagueBasicInfo: this.$store.getters.getLeagueBasicInfo
}
}
}



// WEBPACK FOOTER //
// ./src/views/leagueOngoing_arrange.vue